export default "<button pButton type=\"button\" icon=\"pi pi-list\" class=\"p-button-info\" (click)=\"viewApprovers()\"></button>";